import app from 'flarum/forum/app';
import HeaderDropdown from 'flarum/forum/components/HeaderDropdown';
import classList from 'flarum/common/utils/classList';
import FlagList from './FlagList';
export default class FlagsDropdown extends HeaderDropdown {
  static initAttrs(attrs) {
    attrs.className = classList('FlagsDropdown', attrs.className);
    attrs.label = attrs.label || app.translator.trans('flarum-flags.forum.flagged_posts.tooltip');
    attrs.icon = attrs.icon || 'fas fa-flag';
    super.initAttrs(attrs);
  }
  getContent() {
    return m(FlagList, {
      state: this.attrs.state
    });
  }
  goToRoute() {
    m.route.set(app.route('flags'));
  }
  getUnreadCount() {
    return app.forum.attribute('flagCount');
  }
  getNewCount() {
    return app.session.user.attribute('newFlagCount');
  }
}
flarum.reg.add('flarum-flags', 'forum/components/FlagsDropdown', FlagsDropdown);